import { styled } from "sharedUI/styles";

export const LearningCenterStyle = styled.div`
    display: flex;
    flex-direction: column;

    background-color: ${p => p.theme.bgFront};
    color: ${p => p.theme.textDark};
    box-shadow: ${p => p.theme.shadow4};

    width: 400px;
    height: 100%;

    .header-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: ${p => p.theme.textDark};

        padding: 20px 20px 12px;
        font-weight: 800;
        font-size: 26px;

        .close {
            color: ${p => p.theme.iconBase};
            cursor: pointer;
            :hover {
                color: ${p => p.theme.iconDark};
            }
        }
    }

    .menu-bar {
        display: flex;
        position: relative;

        font-size: 13px;
        padding: 0 12px;

        li {
            cursor: pointer;
            .item-content {
                display: flex;
                align-items: center;
            }
            padding: 8px 12px;
            font-size: 13px;

            list-style: none;

            color: ${p => p.theme.textPale};

            :hover {
                color: ${p => p.theme.textBase};
            }

            .section-icon {
                color: ${p => p.theme.iconPale};
                margin: -5px 0 -5px 3px;
            }

            &.pale {
                color: ${p => p.theme.textXpale};
            }

            z-index: 1;
        }

        .selected {
            font-weight: 700;
            color: ${p => p.theme.b400};

            border-bottom: 2px solid ${p => p.theme.b400};
            padding-bottom: 6px;

            :hover {
                color: ${p => p.theme.b400};
            }
        }

        ::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 1px;
            background-color: ${p => p.theme.n300A};
        }
    }

    .section-content {
        padding: 4px 20px 20px 20px;
        overflow-y: auto;

        .section-item {
            .header {
                font-size: 15px;
                font-weight: 500;
                display: flex;
                justify-content: space-between;
                align-items: center;
                cursor: pointer;

                height: 52px;
            }

            :not(:last-child) {
                border-bottom: 1px solid ${p => p.theme.n300A};
            }

            .section-item-body {
                cursor: pointer;
                padding-bottom: 24px;

                .video-wrapper {
                    overflow: hidden;
                    border-radius: 10px;
                    position: relative;
                }

                .aspect-wrapper {
                    position: relative;
                    width: 100%;
                    padding-bottom: 56.25%;
                }

                .video-thumbnail {
                    position: absolute;
                    left: 0;
                    top: 0;
                    height: 100%;
                    width: 100%;

                    object-fit: cover;
                }

                .play-overlay {
                    pointer-events: none;
                    position: absolute;
                    left: 50%;
                    top: calc(50% + 10px);
                    transform: translate(-50%, -50%);

                    transition: transform 0.15s ease-in-out;
                }

                :hover .play-overlay {
                    transform: translate(-50%, -50%) scale(1.05);
                }
            }
        }
    }
`;
